/**
 * Layered animated SVG waves — used by sections/Hero.jsx and LandingPage hero.
 * Motion is CSS-driven (see index.css .hero-wave-layer--*).
 */
function WaveSvg({ fill, opacity, pathD }) {
  return (
    <svg
      viewBox="0 0 2400 420"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      preserveAspectRatio="none"
      className="h-full w-full"
      style={{ opacity }}
      aria-hidden
    >
      <path fill={fill} d={pathD} />
    </svg>
  );
}

const WAVE1 =
  "M0 260 C400 160 800 360 1200 260 C1600 160 2000 360 2400 260 L2400 420 L0 420 Z";
const WAVE2 =
  "M0 285 C450 200 750 370 1200 285 C1650 200 1950 370 2400 285 L2400 420 L0 420 Z";
const WAVE3 =
  "M0 305 C400 255 800 355 1200 305 C1600 255 2000 355 2400 305 L2400 420 L0 420 Z";

/**
 * @param {"standalone" | "landing"} variant — landing sits on hero-gradient; slightly stronger fills
 * @param {boolean} extended — full hero height (default band is ~52vh); softer opacities so copy stays legible
 */
function HeroWaveBackground({ variant = "standalone", extended = false }) {
  const strong = variant === "landing";
  let o1 = strong ? 0.55 : 0.45;
  let o2 = strong ? 0.95 : 0.9;
  let o3 = strong ? 0.12 : 0.07;
  if (extended) {
    o1 *= 0.72;
    o2 *= 0.78;
    o3 *= 0.85;
  }

  const rootClass = [
    "pointer-events-none absolute inset-0 z-[1] overflow-hidden",
    extended ? "hero-wave-bg--extended" : "",
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <div className={rootClass} aria-hidden>
      <div className="hero-wave-layer hero-wave-layer--a">
        <WaveSvg fill="#2c6e86" opacity={o1} pathD={WAVE1} />
      </div>
      <div className="hero-wave-layer hero-wave-layer--b">
        <svg
          viewBox="0 0 2400 420"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          preserveAspectRatio="none"
          className="h-full w-full"
          style={{ opacity: o2 }}
          aria-hidden
        >
          <defs>
            <linearGradient
              id={`heroWaveOrangeGrad-${variant}`}
              x1="0"
              y1="0"
              x2="0"
              y2="1"
            >
              <stop offset="0%" stopColor="#e76d38" stopOpacity="0.45" />
              <stop offset="100%" stopColor="#73291b" stopOpacity="0.14" />
            </linearGradient>
          </defs>
          <path fill={`url(#heroWaveOrangeGrad-${variant})`} d={WAVE2} />
        </svg>
      </div>
      <div className="hero-wave-layer hero-wave-layer--c">
        <WaveSvg fill="#ffffff" opacity={o3} pathD={WAVE3} />
      </div>
      <div
        className={
          extended
            ? "pointer-events-none absolute inset-x-0 bottom-0 z-[1] h-[45%] max-h-[520px] min-h-[200px] bg-gradient-to-t from-transparent via-white/[0.04] to-transparent"
            : "pointer-events-none absolute inset-x-0 bottom-0 z-[1] h-[min(52vh,480px)] min-h-[160px] bg-gradient-to-t from-transparent via-white/[0.06] to-transparent"
        }
      />
    </div>
  );
}

export default HeroWaveBackground;
